
require("../lib/jquery.autogrow.js");
$('textarea').autogrow();



/*****************
 ** WEBPACK FOOTER
 ** ./chunk/autogrow.js
 ** module id = 3
 ** module chunks = 0
 **/